// PROD-3310 billing bridge.
// Mirrors: dev-scrips-pm-react src/shared/ui/components/patient-avatar.tsx (`PatientAvatar`: name, photoUrl,
// importance (VIP ring), variant "patient" | "provider", size "sm" | "md" | "lg" (22 / 26 / 36) or a number; initials
// on a DJB2-hashed blue/grey pair, never under 12px).
// Wraps:   Signal DS `Avatar` on its `compact` scale, the graduated form of that component: the same three sizes,
// `tone="patient"` (the hashed palette, `patientAvatarPalette`) or `tone="provider"`, and the `importance` VIP ring.
// Overrides: PM's prop names only (`photoUrl` -> `src`, `variant` -> `tone`). PM sizes the disc with an inline style;
// the DS sizes it itself, so nothing inline is needed here.
import { Avatar } from '@scripsteam/scrips-signal-ds';

export type PatientAvatarSize = 'sm' | 'md' | 'lg';
export type PatientAvatarVariant = 'patient' | 'provider';

export interface PatientAvatarProps {
  name: string;
  photoUrl?: string;
  importance?: string | null;
  variant?: PatientAvatarVariant;
  size?: PatientAvatarSize | number;
  className?: string;
}

export function PatientAvatar({
  name,
  photoUrl,
  importance,
  variant = 'patient',
  size = 'md',
  className,
}: PatientAvatarProps) {
  return (
    <Avatar
      scale="compact"
      size={size}
      name={name}
      src={photoUrl}
      tone={variant}
      importance={importance}
      className={className}
    />
  );
}
